export const CODIGO_OMISION_LISTA_NEGRA = "lista_negra";

export const esOmisionListaNegra = (row) =>
  row?.codigo === CODIGO_OMISION_LISTA_NEGRA ||
  (Array.isArray(row?.campos) &&
    row.campos.some((c) => c?.codigo === CODIGO_OMISION_LISTA_NEGRA)) ||
  /lista negra|emisores bloqueados|cuit bloqueado/i.test(
    String(motivoOmitido(row))
  );

export const motivoOmitido = (row) => {
  if (row == null) return "—";
  if (typeof row !== "object") return String(row);

  const texto = String(row.motivo || row.detalle || "").trim();
  if (texto) return texto;

  if (Array.isArray(row.errores) && row.errores.length) {
    return row.errores.filter(Boolean).join(". ");
  }

  if (Array.isArray(row.campos) && row.campos.length) {
    return row.campos
      .map((c) => c?.mensaje)
      .filter(Boolean)
      .join(". ");
  }

  return "—";
};

export const filaOmitido = (row, index) =>
  row?.fila ?? row?.linea ?? row?.nro_fila ?? row?.ref ?? index + 1;

export const refOmitido = (row) =>
  row?.ref || row?.nro_cheque || row?.id_cheque || "";

export const libradorOmitido = (row) => {
  const razon = row?.razon_social_librador || "";
  const cuit = row?.cuit_librador || row?.cuit_recibido || row?.cuit || "";
  const librador = String(row?.librador || "").trim();
  return {
    etiqueta: librador || razon || "—",
    cuit,
  };
};

export const listaOmitidos = (resultado) =>
  Array.isArray(resultado?.omitidos) ? resultado.omitidos : [];

export const resumenOmitidos = (resultado) =>
  Array.isArray(resultado?.omitidos_resumen) ? resultado.omitidos_resumen : [];

export const colorTipoOmision = (tipo, row) => {
  if (esOmisionListaNegra(row)) return "error";
  if (tipo === "invalido") return "error";
  if (tipo === "faltante") return "warning";
  if (tipo === "mixto") return "info";
  return "default";
};

export const omitidoTieneCodigo = (row, codigo) => {
  if (!codigo) return true;
  if (Array.isArray(row?.campos) && row.campos.some((c) => c?.codigo === codigo)) {
    return true;
  }
  return row?.codigo === codigo;
};
